import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../contexts/useAuth'
import type { JwtPayload } from '../../lib/auth'

interface ProtectedRouteProps {
  children: React.ReactNode
  roles?: JwtPayload['role'][]
}

export default function ProtectedRoute({ children, roles }: ProtectedRouteProps) {
  const { user, isLoading } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-page-bg">
        <div className="text-slate-500 text-sm">Loading...</div>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  if (roles && !roles.includes(user.role)) {
    // Land on the v2 home, not the retired v1 dashboard (atlas 2026-07-28:
    // v1 reports zeros beside a live v2 queue, and this redirect was the
    // only way a pilot officer could reach it — the v2 shell links nowhere
    // near it and the catch-all route already sends '*' to /v2).
    return <Navigate to="/v2" state={{ error: 'insufficient_permissions' }} replace />
  }

  return <>{children}</>
}
